$(document).ready(function () {
    // Main Banner
    if($('.main-banner .main-banner-wrapper')){
        var main_banner = new Swiper('.main-banner .main-banner-wrapper',{
            slidesPerView: 1,
            spaceBetween: 10,
            autoHeight: true,
            pagination: {
                el: '.main-banner .main-banner-wrapper .swiper-pagination',
                clickable: true,
            },
            mousewheel: {
                forceToAxis: true
            }
        });
    }
    // Main Banner

    // Infinite scroll text
    if($('.infinite-scroll-text').length > 0){
        $('.infinite-scroll-text').each(function () {
            var scroll_direction = ($(this).data('direction-revers') == true)? 'right':'left';
            var scroll_speed = parseInt($(this).attr('data-desktop-speed'));
            if ($(window).width() < 750) {
                scroll_speed = parseInt($(this).attr('data-mobile-speed'));
            }
            $(this).find('.marquee').marquee({
                gap: 0,
                speed: scroll_speed * 1000,
                direction: scroll_direction,
                duplicated: true,
            });
        });
    }
    // Infinite scroll text


    // Featured collection
    if($('.featured-collection-slider .products-slider--block')){
        var featured_collection_slider = new Swiper('.featured-collection-slider .products-slider--block',{
            slidesPerView: 1.5,
            spaceBetween: 14,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            navigation: {
                nextEl: ".featured-collection-slider .products-slider--block .swiper-button-next",
                prevEl: ".featured-collection-slider .products-slider--block .swiper-button-prev",
            },
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 14,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 14,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
    }
    // Featured collection

    // magazine list
    if($('.magazine-list')){
        var magazine_list = new Swiper('.magazine-list .magazine-list-slider',{
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 800,
            mousewheel: {
                forceToAxis: true
            }
        });
    }
    // magazine list

    // Review Slider
    if($('.review-slider')){
        var review_slider = new Swiper('.review-slider .review-slider-row',{
            slidesPerView: 1,
            spaceBetween: 12,
            navigation: {
                nextEl: ".review-slider .review-slider-row-wrap .swiper-button-next",
                prevEl: ".review-slider .review-slider-row-wrap .swiper-button-prev",
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                901: {
                    slidesPerView: 4,
                    spaceBetween: 12,
                },
            },
            mousewheel: {
                forceToAxis: true
            }
        });
    }
    // Review Slider

    // Article Slider
    if($('.article-slider .article-slider-row')){
        var article_slider = new Swiper('.article-slider .article-slider-row',{
            slidesPerView: 1.5,
            spaceBetween: 14,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            navigation: {
                nextEl: ".article-slider .article-slider-row .swiper-button-next",
                prevEl: ".article-slider .article-slider-row .swiper-button-prev",
            },
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 14,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 14,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
    }
    // Article Slider


    // Featured Products Block
    if($('.featured-products-block') && $(window).width() < 768){
        var featured_products_block_slider = new Swiper('.featured-products-block .featured-products-block-slider',{
            slidesPerView: 1.5,
            spaceBetween: 14,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 14,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                }
            },
        });
    }
    // Featured Products Block
})